import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import isEqual from 'lodash/isEqual';
import { fetchProducts, getYouMayAlsoLike } from '../../../actions/shared/productsData';
import { fetchNextFacets, setCurentFacetsQuery } from '../../../actions/shared/facets';
import { setGridConfig, setGridColumns } from '../../../actions/shared/productGrid';
import { setRequest, setRequestPDP } from '../../../actions/shared/request';
import { DURING_SALE, PRE_BUZZ } from '../PriceRevealPLPBanner/messages';
import { getVariant, getFeatureVariant } from '../../../refresh/organism/ABFeature/Feature';
import productsUtil, {
  parseFacets,
  stringifyFacets,
  buildQuery,
  buildSearch,
  getDefaultQuery,
  buildQueryString,
  parseProductQueryString,
  getSegmentIdsForClient,
  getUserCohortIdsForClient,
  getCustomerTypeForClient
} from '../../../utils/products';
import { isLandingPage } from '../../../utils/common';
import queryUtil from '../../../modules/ajio-util/query';
import { storageAvailable } from '../storageAvailable';

import { trackFetchProduct } from './eventLisiting';
import { gtmPagePush } from '../../../modules/ga/GTMdatalayer';
import { fetchJioBannerAds, initJioAds } from '../../../actions/shared/jioBannerAdsListing';
import { getPreviousSearchSource } from '../../../refresh/selectors/productpage';
import {
  getEnableAdsOnSlp,
  getEnableOspreySearch,
  getEnableVertexSearch,
  getPlpOnLandingEnabled,
  getEnableAdsOnPlp,
  getTrendBasedDiscoveryFlag,
  getTrendBasedDiscoveryConfig
} from '../../../refresh/selectors/featureFlagsSelector';
import { readCookie } from '../../common/Cookie';
import { getPlpOnLandingData } from '../../../refresh/selectors/plpOnLandingSelector';
import { getAmplitudeExperimentVariant, getAmplitudeVariantPayload } from '../../../utils/amplitudeCommon';

function extractVisitorId(gaValue = '') {
  if(!gaValue) {
    return '';
  }
  const parts = gaValue.split('.');
  if (parts.length >= 4) {
    return parts[2] + '.' + parts[3];
  }
  return '';
}

class ProductListContainer extends React.Component {
  constructor(props) {
    super(props);
  }

  buildRequest(routeProps = {}) {
    let {
      request = {},
      requestPDP = {},
      searchInput,
      apiPath,
      pageType,
      deviceType = routeProps?.deviceType,
      params = {},
      productsAdditionalInfo = {},
    } = this.props;
    const { reqObj, isPlpOnLandingEnabled, plpOnLandingCuratedId } = this.props;
    if (pageType == 'pdp' && deviceType == 'mobile') {
      request = reqObj;
    }
    const { location = {} } = window;
    const path = request.browserPath || request.pathname;
    let routePropsQuery = routeProps.query || {};
    const { curatedQuery = {} } = productsAdditionalInfo;
    const { query: Query = '', changeGrid=false } = routePropsQuery;
    let { query: RequestQueryObj = {} } = request;
    let { text: searchText = '' } = RequestQueryObj;
    /**
     * "query" should be freetextSearch:sort-key but over the search looks like
     *  facets and hence the freetextSearch is also preceeded by colon(:).
     * So to remove that colon in (search) flow. We are doing following operation.
     */
    let routePropsQueryString;

    let ignore = {};
    if (location.pathname.includes('/search') || location.pathname.includes('/find')) {
      ignore = { ignore: [searchText || params.cid] };
    }
    const trendsVibesArr = deviceType === 'mobile' ? ['trend', 'vibe'] : [];
    routePropsQueryString = buildQueryString(['sortBy', 'facets', ...trendsVibesArr], {
      ...parseProductQueryString(routePropsQuery.query || '', ignore),
      ...routePropsQuery
    });

    routePropsQuery.query = routePropsQueryString;
    let query = buildQuery(routePropsQuery, {
      blackList: ['clearAllFacets']
    });

    const search = buildSearch(query);
    const catId = request.pathname?.split('/').pop();

    let pathname = `${request.pathname}`;
    if (
      location.pathname.includes('/c/') ||
      location.pathname.includes('/b/') ||
      location.pathname.includes('/fb/') ||
      location.pathname.includes('/fc/')
    ) {
      let cid = params.cid ? params.cid : params.searchInput;
      pathname = `${apiPath}/${cid}`;
    } else if (location.pathname.includes('/s/')) {
      pathname = `${apiPath}/${curatedQuery.curatedid}`;
    } else if (location.pathname.includes('/search') || location.pathname.includes('/find')) {
      pathname = `${request.pathname}`;
    } else if (location.pathname.includes('/cp/')) {
      let cid = params.cid ? params.cid : params.searchInput;
      pathname = `${apiPath}/${cid}`;
      // pathname = `${apiPath}`;
    } else if (location.pathname.includes('/wishlist')) {
      pathname = `${apiPath}`;
    } else if (isPlpOnLandingEnabled && plpOnLandingCuratedId && isLandingPage()) {
      pathname = `${apiPath}/${plpOnLandingCuratedId}`;
    }
    // else if(location.pathname.includes("/capsule/")){
    //   let cid = params.cid ? params.cid : params.searchInput;
    //   pathname = `${apiPath}/${cid}`;
    //   //pathname = `${apiPath}`;
    // }

    const browserPath = location.pathname || routeProps.pathname;
    const nextRequest = {
      ...request,
      query,
      pathname,
      search,
      browserPath,
      defaultQuery: getDefaultQuery(),
      curatedQuery
    };
    return nextRequest;
  }

  getNextRequest(query = {}) {
    const { request = {}, requestPDP = {}, pageType, deviceType, reqObj } = this.props;

    if (pageType === 'pdp' && deviceType === 'mobile') {
      return this.buildRequest({
        ...reqObj,
        query: { ...reqObj.query, ...query }
      });
    }
    return this.buildRequest({
      ...request,
      query: { ...request.query, ...query }
    });
  }

  getCuratedQueryDiff(currQuery = {}, curatedQuery = '') {
    if (!curatedQuery) {
      return curatedQuery;
    }
    const curatedQueryObj = queryUtil.parseSearch(curatedQuery || '');
    const curatedQueryStrObj = parseProductQueryString(curatedQueryObj.query || '');

    const currQueryFacets = parseFacets(currQuery.facets || '');
    const curatedQueryFacets = parseFacets(curatedQueryStrObj.facets || '');
    Object.keys(currQueryFacets).map(key => {
      if (isEqual(currQueryFacets[key], curatedQueryFacets[key])) {
        delete currQueryFacets[key];
      }
    });
    if (currQuery.sortBy == curatedQueryStrObj.sortBy) {
      // delete currQuery.sortBy;
    }

    currQuery.facets = stringifyFacets(currQueryFacets);
    return currQuery;
  }

getTrendData(){
    const { trendBasedDiscoveryFlag = {}, trendsData = [] } = this.props;
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const isTrendWidget = urlParams.get('isTrendWidget') || "";
    const trendId = urlParams.get('trendId');
    const tagName = urlParams.get('tagName');
    const trendType = urlParams.get('type');
    const brickValue = urlParams.get('value');
    let trendObj = {}
    if (trendBasedDiscoveryFlag?.master) {
      if (isTrendWidget === 'true' && trendId && trendsData?.length > 0) {
        const trendData = trendsData?.filter(item => item?.trendId === trendId);
        const trendName = trendData?.[0]?.displayName;
        if (trendName) {
          trendObj = {
            trend: `trend:${trendName}`
          };
        }
      } else if (isTrendWidget === 'true' && tagName) {
        trendObj = {
          trend: `trend:${tagName}`,
        };
      } else if (isTrendWidget === 'false' && tagName) {
        trendObj = {
          vibe: `vibe:${tagName}`
        };
      } else if(isTrendWidget === 'true' && trendsData?.length > 0){
        trendObj = {
          vibe: `trend:${trendsData?.[0]?.displayName}`
        };
      }
      if ((isTrendWidget === 'true' || isTrendWidget === 'false') && trendType?.toLowerCase() === 'brick' && brickValue) {
        trendObj = { ...trendObj, l1l3nestedcategory: brickValue };
      }
    }
    return trendObj;
  }

  removeDefaultsNotInInputQuery = (inputQuery = {}, search = '', curatedQuery) => {
    if ((inputQuery.sortBy || inputQuery.facets) && !curatedQuery) {
      return search;
    }
    const { location = {} } = window;
    const { href = '' } = location;
    const query = queryUtil.parseSearch(search || '');
    const browserQuery = queryUtil.parseSearch(location.href.split('?')[1] || '');
    if (query.query) {
      const defaultQuery = getDefaultQuery();
      let queryStrObj = parseProductQueryString(query.query || '');
      const finalQuery = this.getCuratedQueryDiff({ ...queryStrObj }, curatedQuery);
      const browserQueryStrObj = parseProductQueryString(browserQuery.query || '');
      if (
        !browserQueryStrObj.sortBy &&
        finalQuery.sortBy &&
        finalQuery.sortBy == defaultQuery.sortBy
      ) {
        if (finalQuery.query) {
          finalQuery.sortBy = queryStrObj.sortBy;
        }
        if (inputQuery.sortBy) {
          finalQuery.sortBy = inputQuery.sortBy;
        } else {
          delete finalQuery.sortBy;
        }
        query.query = buildQueryString(['sortBy', 'facets'], finalQuery);
        if ('query' in query && !query.query) {
          delete query.query;
        }

        return buildSearch(query);
      } else {
        if (finalQuery.query) {
          finalQuery.sortBy = queryStrObj.sortBy;
        }
        if (inputQuery.sortBy) {
          finalQuery.sortBy = inputQuery.sortBy;
        } else if (!browserQueryStrObj.sortBy) {
          delete finalQuery.sortBy;
        }
        query.query = buildQueryString(['sortBy', 'facets'], finalQuery);
        if ('query' in query && !query.query) {
          delete query.query;
        }
        return buildSearch(query);
      }
    }
    return search;
  };

  pushToHistory = (query = {}, pushInHistory = true) => {
    this.onFilterApplied({ ...query });
    const {
      history = {},
      request = {},
      store = '',
      pageType,
      deviceType,
      newDesignLuxe,
      priceRevealState,
      previousSource = {},
      isOspreySearchEnabled,
      isVertexSearchEnabled,
      isVertexCategoryEnabled,
      isPlpOnLandingEnabled,
      plpOnLandingCuratedId,
      enableUniversalCohortFlow,
      enableSegmentIdVertex,
      trendBasedDiscoveryFlag = {},
      trendsData = []
    } = this.props;
    const trendObj = this.getTrendData();
    const queryData = {
      ...trendObj,
      ...query,
    }
    const {
      isRequestFromPlpOnLanding = false,
      displayProductsOnLandingLoader = false,
      changeGrid = false,
      ...restQuery
    } = queryData;

    let nextRequest = this.getNextRequest(restQuery) || {};
      nextRequest = {
        ...nextRequest,
        query: {
          ...(trendObj || {}),
          ...(nextRequest.query || {}),
          ...(changeGrid ? { currentPage: 0 } : {})
        }
      };

    const visitorId = readCookie('_ga');
    const CICookie = readCookie('CI');
    const EICookie = readCookie('PK');
    const userState = (readCookie('LS') === 'LOGGED_IN') ? 'LOGGED_IN' : 'NON_LOGGED_IN';
    const zone = readCookie('ZN') || '';
    const state = readCookie('ST') || '';
    const city = readCookie('CT') || '';
    const segment_device_id = readCookie('segment_device_id') || '';
    const updatedVisitorId = enableSegmentIdVertex ? segment_device_id : extractVisitorId(visitorId);

    const {
      enableClusterFeatureflag,
      enableAdsOnPlpFlag,
      enableAdsOnSlpFlag,
      showAdsOnNextPage,
      enablePlaOnPLP=false,
      plaAdsEliminationDisabled=false,
      isPlpBannerOsmosEnabled=false,
      osmosPlpBannerSlotsOrder={}
    } = this.props;
    const { location = {} } = window;
    const segmentIds = getSegmentIdsForClient();
    const cohortIds = getUserCohortIdsForClient(store, 'plp', enableUniversalCohortFlow);
    const customerType = getCustomerTypeForClient();
    nextRequest.query.segmentIds = segmentIds;
    nextRequest.query.userClusterId = cohortIds;
    nextRequest.query.customertype = customerType;

    if (this.shouldFetchProducts(nextRequest, request)) {
      const shouldScrollToTop = !(isPlpOnLandingEnabled && plpOnLandingCuratedId && isLandingPage());
      this.props.fetchProducts({
        request: nextRequest,
        store,
        enableClusterFeatureflag,
        enableAdsOnPlpFlag,
        enableAdsOnSlpFlag,
        showAdsOnNextPage,
        ...((previousSource) && { previousSource }),
        isOspreySearchEnabled,
        isVertexSearchEnabled,
        ...((isVertexSearchEnabled || isVertexCategoryEnabled) && { updatedVisitorId }),
        isRequestFromPlpOnLanding,
        displayProductsOnLandingLoader,
        isPLAEnabled: enablePlaOnPLP,
        plaAdsEliminationDisabledFlag: plaAdsEliminationDisabled,
        plpBannerAdsEnabled: isPlpBannerOsmosEnabled,
        osmosPlpBannerSlotsOrder,
        zone,
        state, 
        city, 
        userRestriction: customerType,
        userState,
        customerUID: CICookie,
        segmentAnonymousId: segment_device_id,
        callBack: shouldScrollToTop ? () => window.scrollTo(0, 0) : undefined,
      });
    } else {
      if (pageType === 'pdp' && deviceType === 'mobile') {
        this.props.setRequestPDP(nextRequest);
      } else {
        this.props.setRequest(nextRequest);
      }
      if (nextRequest.query && nextRequest.query.gridColumns) {
        this.props.setGridColumns(nextRequest.query.gridColumns);
      }
    }
    if (trendBasedDiscoveryFlag?.master) {
      const currentParams = new URLSearchParams(window.location.search);
      const isTrendWidget = currentParams.get('isTrendWidget');
      if (isTrendWidget === 'true') {
        const tagName = currentParams.get('tagName');
        const urlTrendId = currentParams.get('trendId');
        const searchParams = new URLSearchParams((nextRequest.search || '').replace(/^\?/, ''));
        // Always preserve isTrendWidget so TrendsPLPSlider remains visible
        searchParams.set('isTrendWidget', 'true');
        // Clear both to avoid stale values from initial request.query persisting
        searchParams.delete('trendId');
        searchParams.delete('tagName');
        if (tagName && !urlTrendId) {
          // User clicked a different card — tagName is the source of truth
          searchParams.set('tagName', tagName);
        } else if (urlTrendId) {
          // Still on the original card from the initial redirect
          searchParams.set('trendId', urlTrendId);
        }
        nextRequest.search = `?${searchParams.toString()}`;
      }
    }

    if (pushInHistory) {
      history.push({
        pathname: nextRequest.browserPath,
        search: nextRequest.search
      });
    }
  };

  replaceInHistory = (query = {}) => {
    this.onFilterApplied({ ...query });
    const { history = {}, request = {}, store = '', pageType, deviceType } = this.props;
    const trendObj = this.getTrendData();
    const queryData = {
      ...trendObj,
      ...query,
    }
    const {
      isRequestFromPlpOnLanding = false,
      displayProductsOnLandingLoader = false,
      isPriceFilterFromPlpLandingPage = false,
      callBack,
      ...restQuery
    } = queryData;
    let nextRequest = this.getNextRequest(restQuery);
    const {
      enableClusterFeatureflag,
      enableAdsOnPlpFlag,
      enableAdsOnSlpFlag,
      showAdsOnNextPage,
      previousSource = {},
      isOspreySearchEnabled,
      isVertexSearchEnabled,
      isVertexCategoryEnabled,
      enableUniversalCohortFlow,
      enablePlaOnPLP=false,
      plaAdsEliminationDisabled=false,
      isPlpBannerOsmosEnabled=false,
      osmosPlpBannerSlotsOrder={},
      enableSegmentIdVertex=false
    } = this.props;
    const visitorId = readCookie('_ga');
    const CICookie = readCookie('CI');
    const EICookie = readCookie('PK');
    const userState = (readCookie('LS') === 'LOGGED_IN') ? 'LOGGED_IN' : 'NON_LOGGED_IN';
    const zone = readCookie('ZN') || '';
    const state = readCookie('ST') || '';
    const city = readCookie('CT') || '';
    const segment_device_id = readCookie('segment_device_id') || '';
    const updatedVisitorId = enableSegmentIdVertex ? segment_device_id : extractVisitorId(visitorId);

    const { location = {} } = window;
    const segmentIds = getSegmentIdsForClient();
    const cohortIds = getUserCohortIdsForClient(store, 'plp', enableUniversalCohortFlow);
    const customerType = getCustomerTypeForClient();
    nextRequest.query.segmentIds = segmentIds;
    nextRequest.query.userClusterId = cohortIds;
    nextRequest.query.customertype = customerType;

    if (this.shouldFetchProducts(nextRequest, request)) {
      const scrollAfterFetch = () => {
        if (!isRequestFromPlpOnLanding) {
          window.scrollTo(0, 0);
        }
        if (callBack) callBack();
      };
      this.props.fetchProducts({
        request: nextRequest,
        store,
        enableClusterFeatureflag,
        enableAdsOnPlpFlag,
        enableAdsOnSlpFlag,
        showAdsOnNextPage,
        ...((previousSource) && { previousSource }),
        isOspreySearchEnabled,
        isVertexSearchEnabled,
        isVertexCategoryEnabled,
        ...((isVertexSearchEnabled || isVertexCategoryEnabled) && { updatedVisitorId }),
        isRequestFromPlpOnLanding,
        isPriceFilterFromPlpLandingPage,
        callBack: scrollAfterFetch,
        isPLAEnabled: enablePlaOnPLP,
        plaAdsEliminationDisabledFlag: plaAdsEliminationDisabled,
        plpBannerAdsEnabled: isPlpBannerOsmosEnabled,
        osmosPlpBannerSlotsOrder,
        zone,
        state, 
        city, 
        userRestriction: customerType,
        userState,
        customerUID: CICookie,
        segmentAnonymousId: segment_device_id,
      });
    } else {
      if (pageType === 'pdp' && deviceType === 'mobile') {
        this.props.setRequestPDP(nextRequest);
      } else {
        this.props.setRequest(nextRequest);
      }

      if (nextRequest.query && nextRequest.query.gridColumns) {
        this.props.setGridColumns(nextRequest.query.gridColumns);
      }
    }

    const { trendBasedDiscoveryFlag: trendFlag = {} } = this.props;
    if (trendFlag?.master) {
      const currentParams = new URLSearchParams(window.location.search);
      const isTrendWidget = currentParams.get('isTrendWidget');
      if (isTrendWidget === 'true') {
        const tagName = currentParams.get('tagName');
        const urlTrendId = currentParams.get('trendId');
        const searchParams = new URLSearchParams((nextRequest.search || '').replace(/^\?/, ''));
        searchParams.set('isTrendWidget', 'true');
        searchParams.delete('trendId');
        searchParams.delete('tagName');
        if (tagName && !urlTrendId) {
          searchParams.set('tagName', tagName);
        } else if (urlTrendId) {
          searchParams.set('trendId', urlTrendId);
        }
        nextRequest.search = `?${searchParams.toString()}`;
      }
    }

    history.replace({
      pathname: nextRequest.browserPath,
      search: nextRequest.search
    });
  };

  fetchNextFacets = (query, id) => {
    const { request = {}, store = '' } = this.props;
    const {
      isRequestFromPlpOnLanding = false,
      displayProductsOnLandingLoader = false,
      ...restQuery
    } = query;
    let nextRequest = this.getNextRequest(restQuery);
    if(nextRequest && nextRequest.currentPage && nextRequest.query && nextRequest.query.currentPage) {
      nextRequest.currentPage = 0;
      nextRequest.query.currentPage = 0;
    }
    this.props.fetchNextFacets({
      request: nextRequest,
      query: parseFacets(nextRequest.query.facets),
      id,
      store,
      isRequestFromPlpOnLanding,
      displayProductsOnLandingLoader,
      cb: query?.cb
    });
  };

  loadMoreItems = (isPlpOnLandingLoadMore, callBack) => {
    const {
      request,
      requestPDP,
      store = '',
      pageType,
      deviceType,
      reqObj = {},
      isDyanamicWidget = false,
      plpOnLandingData = {},
      isFilterImprovementEnabled = false,
      isFilterImprovementPhase2Enabled = false,
      isPlpOnLandingPage = false,
      enableSegmentIdVertex=false
    } = this.props;
    const { pagination = {} } = plpOnLandingData;
    const { currentPage = 0, totalPages = 1 } = pagination;
    const visitorId = readCookie('_ga');
    const CICookie = readCookie('CI');
    const EICookie = readCookie('PK');
    const userState = (readCookie('LS') === 'LOGGED_IN') ? 'LOGGED_IN' : 'NON_LOGGED_IN';
    const zone = readCookie('ZN') || '';
    const state = readCookie('ST') || '';
    const city = readCookie('CT') || '';
    const customerType = getCustomerTypeForClient();
    const segment_device_id = readCookie('segment_device_id') || '';
    const updatedVisitorId = enableSegmentIdVertex ? segment_device_id : extractVisitorId(visitorId);

    if (isPlpOnLandingLoadMore && currentPage + 1 >= totalPages) {
      return;
    }

    const catId = pageType === 'pdp' ? reqObj?.pathname.split('/')[3] || '83' : '';
    let query = {};
    if (pageType === 'pdp' && deviceType === 'mobile') {
      query = {
        ...reqObj.query,
        currentPage: reqObj.query.currentPage + 1
      };
    } else {
      query = {
        ...request.query,
        currentPage: request.query.currentPage + 1
      };
    }

    if (isDyanamicWidget) {
      query = {
        ...query,
        isDynamicWidget: true
      };
    }

    if(currentPage <= 1){
      const trendObj = this.getTrendData();
      query = {
        ...trendObj,
        ...query
      };
    }

    const nextRequest = this.getNextRequest(query);
    const appendNewProducts = true;
    const {
      enableClusterFeatureflag,
      enableAdsOnPlpFlag,
      enableAdsOnSlpFlag,
      showAdsOnNextPage,
      enablePlaOnPLP=false,
      plaAdsEliminationDisabled=false,
      isPlpBannerOsmosEnabled=false,
      osmosPlpBannerSlotsOrder={}
    } = this.props;
    const reqData =
      pageType === 'pdp'
        ? {
            ...nextRequest,
            pathname: `/api/category/${catId}`,
            deviceType: 'mobile',
            headerInfo: { referer: '/p/' }
          }
        : nextRequest;
    const { previousSource = {}, isOspreySearchEnabled, isVertexSearchEnabled, isVertexCategoryEnabled } = this.props;
    this.props.fetchProducts({
      request: reqData,
      appendNewProducts,
      store,
      enableClusterFeatureflag,
      enableAdsOnPlpFlag,
      enableAdsOnSlpFlag,
      showAdsOnNextPage,
      ...((previousSource) && { previousSource }),
      isOspreySearchEnabled,
      isVertexSearchEnabled,
      isVertexCategoryEnabled,
      ...((isVertexSearchEnabled || isVertexCategoryEnabled) && { updatedVisitorId }),
      isPlpOnLandingLoadMore,
      plpOnLandingFeedLogic: plpOnLandingData?.widgetRecord ?? {},
      callBack,
      isPLAEnabled: enablePlaOnPLP,
      plaAdsEliminationDisabledFlag: plaAdsEliminationDisabled,
      plpBannerAdsEnabled: isPlpBannerOsmosEnabled,
      osmosPlpBannerSlotsOrder,
      zone,
      state, 
      city, 
      userRestriction: customerType,
      userState,
      isFilterImprovementEnabled,
      isFilterImprovementPhase2Enabled,
      isPlpOnLandingPage,
      customerUID: CICookie,
      segmentAnonymousId: segment_device_id,
    });
  };

  onFilterApplied = (filters = {}) => {
    if (filters.facets == null && filters.sortBy == null) {
      return;
    }
    const { location = {} } = window;
    var isLocalStorage = storageAvailable('localStorage');
    if (isLocalStorage) {
      let plpFilter = localStorage.getItem('plpFilter');
      plpFilter = plpFilter ? JSON.parse(plpFilter) : {};
      if (plpFilter.pathname !== location.pathname) {
        plpFilter = { pathname: location.pathname };
      }
      plpFilter = { ...plpFilter, ...filters };
      localStorage.setItem('plpFilter', JSON.stringify(plpFilter));
    }
  };

  getFiltersApplied = (filters = {}) => {
    const { location = {} } = window;
    if (storageAvailable('localStorage')) {
      var plpFilter = localStorage.getItem('plpFilter');
    }
    plpFilter = plpFilter ? JSON.parse(plpFilter) : null;
    if (!plpFilter) return [];
    if (plpFilter.pathname !== location.pathname) {
      return [];
    }

    const { href = '' } = location;
    const browserQuery = queryUtil.parseSearch(href.split('?')[1] || '');

    const browserQueryStrObj = parseProductQueryString(browserQuery.query || '');
    const filtersApplied = [];
    if (
      browserQueryStrObj.sortBy &&
      plpFilter.sortBy &&
      browserQueryStrObj.sortBy === plpFilter.sortBy
    ) {
      filtersApplied.push('sortBy');
    }

    if (plpFilter.facets) {
      filtersApplied.push('facets');
    }

    return filtersApplied;
  };

  updateGridColumns = cols => {
    this.props.setGridColumns(cols);
  };

  render() {
    const {
      location,
      history,
      searchInput,
      isRequestOrginIsBrowser,
      hasErrored,
      params,
      errorDetails
    } = this.props;
    return (
      <div>
        {this.props.children({
          location,
          history,
          searchInput,
          params,
          loadMoreItems: this.loadMoreItems,
          pushToHistory: this.pushToHistory,
          replaceInHistory: this.replaceInHistory,
          fetchNextFacets: this.fetchNextFacets,
          onFilterApplied: this.onFilterApplied,
          getFiltersApplied: this.getFiltersApplied,
          getFiltersApplied: this.getFiltersApplied,
          updateGridColumns: this.updateGridColumns,
          isRequestOrginIsBrowser,
          hasErrored,
          errorDetails
        })}
      </div>
    );
  }

  setRequestToLocalStorage() {
    const { request = {} } = this.props;
    const { location = {} } = window;
    const { href } = location;
    var isLocalStorage = storageAvailable('localStorage');
    if (isLocalStorage) {
      var storageRequest = localStorage.getItem('plpRequestMobile');
    }
    if (storageRequest) {
      try {
        storageRequest = JSON.parse(storageRequest);
      } catch (e) {}
    }
    storageRequest = storageRequest || {};
    if (!storageRequest.href || storageRequest.href !== location.href) {
      if (isLocalStorage) {
        localStorage.setItem(
          'plpRequestMobile',
          JSON.stringify({
            href,
            request
          })
        );
      }
    }
  }

  savePageCategory = () => {
    const { productsAdditionalInfo = {} } = this.props;
    const breadcrumb = productsAdditionalInfo?.rilfnlBreadCrumbList?.rilfnlBreadCrumb;
    if (Array.isArray(breadcrumb) && breadcrumb.length > 0) {
      const isSearchOrFind =
        window.location.pathname.startsWith('/search') ||
        window.location.pathname.startsWith('/find');
      const pageCategory = breadcrumb
        .map(b => {
          let name = b?.name || '';
          if (isSearchOrFind) {
            name = name?.split(':')[0] || name;
          }
          return name?.trim();
        })
        .filter(Boolean)
        .join(' > ');
      if (pageCategory) {
        localStorage.setItem('pageCategory', pageCategory);
      }
    }
  };

  saveAttributionToken = () => {
    const { productsAdditionalInfo = {} } = this.props;
    const token = productsAdditionalInfo?.attributionToken;
    const ttl = 60 * 60 * 1000; // seeting it for 60 mins as avg session time
    const now = Date.now();
    if (token) {
      try {
        const existingRaw = localStorage.getItem('attributionToken');
        const existing = existingRaw ? JSON.parse(existingRaw) : null;
        const isExpired = !existing || existing.value !== token || now >= existing.expiry;
        if (isExpired) {
          const tokenData = {
            value: token,
            expiry: now + ttl
          };
          localStorage.setItem('attributionToken', JSON.stringify(tokenData));
        }
      } catch {
        localStorage.removeItem('attributionToken');
      }
    }    
    else
    {
      localStorage.removeItem('attributionToken');
    }
  };
  

  parseFacet = () => {
    const queryString = queryUtil.parseSearch(window.location.search) || {};
    const query = parseProductQueryString(queryString.query || '');
    const { facets } = query;
    const facetsQuery = productsUtil.parseFacets(facets);
    this.props.setCurentFacetsQuery(facetsQuery);
  };

  getCuratedIdFromUrl = (curPath = '', curPattern = '') => {
    let curatedUrlPaths = '';
    if (curPattern.test(curPath)) {
      curatedUrlPaths = curPath.split('/s/');
      curatedUrlPaths = curatedUrlPaths[curatedUrlPaths.length - 1];
      return curatedUrlPaths || '';
    }
    return '';
  };

  componentDidMount() {
    const { location: { pathname: curPathName = '' } = {} } = window || {};
    const userState = (readCookie('LS') === 'LOGGED_IN') ? 'LOGGED_IN' : 'NON_LOGGED_IN';
    const zone = readCookie('ZN') || '';
    const state = readCookie('ST') || '';
    const city = readCookie('CT') || '';
    const CICookie = readCookie('CI') || '';
    const customerType = readCookie('customerType') || '';
    const segment_device_id = readCookie('segment_device_id') || '';

    const curPagePattern = /^\/s\/.*$/i;

    this.setRequestToLocalStorage();
    this.saveAttributionToken();
    this.savePageCategory();
    const { history = {}, store = '', request = {} } = this.props;
    let currSearch = window.location.search;
    // this.props.initJioAds()
    history.listen((routeProps, action) => {
      /**
       * Setting Facets query
       */
      this.parseFacet();

      const next_req = {
        query: {
          ...getDefaultQuery(),
          ...queryUtil.parseSearch(routeProps.search)
        },
        browserPath: routeProps.pathname
      };

      const curr_req = {
        query: {
          ...getDefaultQuery(),
          ...queryUtil.parseSearch(currSearch)
        },
        ...request
      };
      curr_req.browserPath = routeProps.pathname;
      if (!routeProps.hash) {
        currSearch = routeProps.search;
      }

      if (action == 'POP') {
        if (!routeProps.hash && this.shouldFetchProducts(next_req, curr_req)) {
          let query = null;
          let nextQuery = {
            ...curr_req,
            ...next_req
          };

          if (nextQuery && nextQuery.query && nextQuery.query.query) {
            query = parseProductQueryString(nextQuery.query.query);

            nextQuery.query.sortBy = query.sortBy;
            if (query.sortBy && query.sortBy == getDefaultQuery().sortBy) {
              delete query.sortBy;
            }
            /**
             * Whenever page is landing to URL without any query parameters.
             * We should fetch the product list based using default query.
             *
             * Setting query.facets = ""; because comparater method expects
             * every key with some value. If the key is missing it will pick
             * last value for that key.
             *
             * Like in search page applying facet after filter. (On navigation back we need to reset facets)
             */
            if (Object.keys(query).length == 0) {
              nextQuery.query.facets = '';
              const nextRequest = this.getNextRequest(nextQuery.query);
              let path = nextRequest.browserPath || nextRequest.pathname;

              if (path.includes('/s/') && nextQuery.query.facets === '') {
                let {
                  curatedQuery: { id: curatedid = '', curated = true, facets = '' } = {}
                } = nextQuery;
                /**
                 * Modified below line to handle empty cureatedid issue. Jira: 190934
                 * Considering 'curatedid' from page url, if inherited 'curatedid' value is empty
                 */
                nextRequest.query.curatedid =
                  curatedid || this.getCuratedIdFromUrl(curPathName, curPagePattern);
                nextRequest.query.curated = curated;
                nextRequest.query.facets = facets;
                nextRequest.query.query = !nextRequest.query.query.includes(facets)
                  ? `${nextRequest.query.query}:${facets}`
                  : nextRequest.query.query;

                const facetsQuery = productsUtil.parseFacets(facets);
                this.props.setCurentFacetsQuery(facetsQuery);
              }
              const {
                enableClusterFeatureflag,
                enableAdsOnPlpFlag,
                enableAdsOnSlpFlag,
                showAdsOnNextPage,
                earlyAccessFlag,
                enablePlaOnPLP,
                plaAdsEliminationDisabled,
                isPlpBannerOsmosEnabled
              } = this.props;

              this.props.fetchProducts({
                request: nextRequest,
                store,
                enableClusterFeatureflag,
                enableAdsOnPlpFlag,
                enableAdsOnSlpFlag,
                showAdsOnNextPage,
                isPLAEnabled: enablePlaOnPLP,
                plaAdsEliminationDisabledFlag: plaAdsEliminationDisabled,
                plpBannerAdsEnabled: isPlpBannerOsmosEnabled,
                osmosPlpBannerSlotsOrder,
                zone,
                state, 
                city, 
                userRestriction: customerType,
                userState,
                customerUID: CICookie,
                segmentAnonymousId: segment_device_id,
                callBack: () => window.scrollTo(0, 0),
              });
            } else {
              nextQuery.query.facets = query.facets ? query.facets : '';
              this.pushToHistory(nextQuery.query, false);
            }
          }
        }
      }
    });
    // gtmPagePush(false, 'product listing page', window.__ENV__, {item_count: request.totalResults});
  }

  componentDidUpdate(prevProps) {
    const prevToken = prevProps.productsAdditionalInfo?.attributionToken;
    const newToken = this.props.productsAdditionalInfo?.attributionToken;
    if (newToken && prevToken !== newToken) {
      this.saveAttributionToken();
    }
    const prevBreadcrumb = prevProps.productsAdditionalInfo?.rilfnlBreadCrumbList?.rilfnlBreadCrumb;
    const newBreadcrumb = this.props.productsAdditionalInfo?.rilfnlBreadCrumbList?.rilfnlBreadCrumb;
    if (newBreadcrumb && prevBreadcrumb !== newBreadcrumb) {
      this.savePageCategory();
    }
  }

  shouldFetchProducts(nextRequest, currRequest = {}, id) {
    const { query: nextQuery = {} } = nextRequest;
    const currQuery = {
      ...getDefaultQuery(),
      ...currRequest.query,
      ...queryUtil.parseSearch(currRequest.search)
    };

    const queryDiff = Object.keys(nextQuery)
      .reduce((acc, q_key) => {
        if (nextQuery[q_key] != currQuery[q_key]) {
          acc.push(q_key);
        }
        return acc;
      }, [])
      .filter(item => {
        const blackList = ['hash', 'gridColumns', 'viewType'];
        return !blackList.includes(item);
      });
    if (nextRequest.browserPath !== currRequest.browserPath) {
      return true;
    } else if (queryDiff.length < 1) {
      return false;
    }
    return true;
  }
}

const mapStateToProps = (state, ownProps) => {
  const {
    request = {},
    requestPDP = {},
    products = {},
    productsAdditionalInfo = {},
    metaData = {},
    flags = {},
    product: { reqObj = {} } = {}
  } = state;
  const { isRequestOrginIsBrowser, hasErrored, errorDetails } = products;
  const { location, history, match = {} } = ownProps;
  const { params = {} } = match;
  const { searchInput } = params;
  const { name = '' } = metaData;
  const { showAdsOnNextPage = false } = productsAdditionalInfo;
  const { enableClusterFeature, enableCategoryWidgetsVertex = false } = flags;
  const enableClusterFeatureflag = enableClusterFeature === 'ON';
  const enableAdsOnPlpFlag = getEnableAdsOnPlp(state);
  const enableAdsOnSlpFlag = getEnableAdsOnSlp(state);
  const previousSource = getPreviousSearchSource(state);
  const isOspreySearchEnabled = getEnableOspreySearch(flags);
  const isVertexSearchEnabled = getEnableVertexSearch(flags);
  const isVertexCategoryEnabled = getAmplitudeVariantPayload('enableCategoryWidgetsVertex', state, enableCategoryWidgetsVertex) && getAmplitudeExperimentVariant('vertex-exp-flag',state);
  const enableUniversalCohortFlow = getAmplitudeVariantPayload('enableUniversalCohortFlow', state, false)
  const isPlpOnLandingEnabled = getPlpOnLandingEnabled(state);
  const plpOnLandingData = getPlpOnLandingData(state);
  const enablePlaOnPLP = getAmplitudeExperimentVariant('enable-pla-on-plp-osmos', state);
  const plaAdsEliminationDisabled = getAmplitudeExperimentVariant('disable-pla-elimination-plp', state);
  const isPlpBannerOsmosEnabled  = getAmplitudeExperimentVariant('enable-plp-banners-plp-osmos', state);
  const osmosPlpBannerSlotsOrder = getAmplitudeVariantPayload('osmosPlpBannerSlots', state, {});
  const enableSegmentIdVertex = getAmplitudeVariantPayload('enableSegmentIdVertex', state, false);
  const trendBasedDiscoveryFlag = getTrendBasedDiscoveryConfig(state);
  const trendsData = state?.products?.trendsData || [];

  const { curatedid: plpOnLandingCuratedId = '' } = plpOnLandingData || {};
  return {
    location,
    history,
    request,
    requestPDP,
    searchInput,
    params,
    isRequestOrginIsBrowser,
    hasErrored,
    errorDetails,
    productsAdditionalInfo,
    store: name,
    enableClusterFeatureflag,
    enableAdsOnPlpFlag,
    enableAdsOnSlpFlag,
    showAdsOnNextPage,
    reqObj,
    previousSource,
    isOspreySearchEnabled,
    isVertexSearchEnabled,
    isVertexCategoryEnabled,
    enableUniversalCohortFlow,
    isPlpOnLandingEnabled,
    plpOnLandingCuratedId,
    enablePlaOnPLP,
    plaAdsEliminationDisabled,
    isPlpBannerOsmosEnabled,
    osmosPlpBannerSlotsOrder,
    enableSegmentIdVertex,
    trendBasedDiscoveryFlag,
    trendsData
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchProducts: params => {
      // trackFetchProduct(params,"REQ");
      dispatch(fetchProducts({ ...params, isRequestOrginIsBrowser: true }));
    },
    fetchNextFacets: params => dispatch(fetchNextFacets(params)),
    setGridConfig: props => {
      dispatch(setGridConfig(props));
    },
    setRequest: request => {
      dispatch(setRequest(request));
    },
    setRequestPDP: requestPDP => {
      dispatch(getYouMayAlsoLike(requestPDP));
    },
    setGridColumns: gridColumns => {
      dispatch(setGridColumns(gridColumns));
    },
    setCurentFacetsQuery: query => {
      dispatch(setCurentFacetsQuery(query));
    },
    fetchJioBannerAds: data => dispatch(fetchJioBannerAds(data)),
    initJioAds: data => dispatch(initJioAds(data))
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ProductListContainer));
